import { JSONValue } from '@lucidtech/las-sdk-browser';
import { useEffect, useState } from 'react';

import { toAgentId, toFileId, useBatchGetFile, useListAgentRuns } from '@/hooks/api';

export const useGetSamplePayloads = (agentId?: string | null, maxResults?: number) => {
  const {
    data: { data: runs } = {},
    refetch,
    isPending: isPendingAgentRuns,
  } = useListAgentRuns({
    ...toAgentId(agentId),
    maxResults: maxResults ?? 3,
    sort: [{ column: 'createdTime', order: 'desc' }],
    status: ['completed', 'error'],
  });

  const { data: files, isPending: isPendingFiles } = useBatchGetFile(
    runs?.map((run) => toFileId(run.variablesFileUrl))
  );

  const [payloads, setPayloads] = useState<JSONValue[]>([]);

  useEffect(() => {
    Promise.all(files.map(async (file) => await file.text())).then((fileContents) => {
      const payloads: JSONValue[] = [];

      for (const content of fileContents) {
        payloads.push(JSON.parse(content));
      }

      setPayloads(payloads);
    });
  }, [files]);

  return { runs, payloads, refetch, isPending: isPendingAgentRuns || isPendingFiles };
};
